import React from 'react';
import { List, Input, TextArea } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import DateInput from '../Section/DateInput';

const InputsSection = ({
  onInputChange,
  onDateChange,
  currentSectionPaxData,
  language
}) => {
  const renderElement = ({ name, id, icon, value, type, ...inputProps }) => {
    const defaultFieldType = type.includes('float') ? 'number' : type;
    const handleIntegerInputChange = (event, element) => {
      if (/^[0-9]*$/.test(element.value)) {
        return onInputChange(event, element);
      }
    };

    switch (type) {
      case 'textarea':
        return (
          <TextArea
            id={id}
            {...inputProps}
            size="small"
            onChange={onInputChange}
            type={type}
            value={value}
            className="section-textarea"
          />
        );
      case 'date':
      case 'date_time':
        return (
          <DateInput
            type={type}
            value={value}
            onDateChange={onDateChange}
            language={language}
            id={id}
          />
        );
      case 'integer':
        return (
          <Input
            id={id}
            fluid
            {...inputProps}
            size="small"
            onChange={handleIntegerInputChange}
            icon={icon}
            type="text"
            inputMode="numeric"
            value={value || ''}
            iconPosition={icon && 'left'}
            placeholder="0"
          />
        );
      default:
        return (
          <Input
            id={id}
            fluid
            {...inputProps}
            size="small"
            onChange={onInputChange}
            icon={icon}
            type={defaultFieldType}
            value={value || ''}
            iconPosition={icon && 'left'}
            placeholder={type.includes('float') ? '0,00' : ''}
          />
        );
    }
  };
  return (
    <List>
      {currentSectionPaxData.map(inputProps => {
        if (inputProps.type === 'function') return null;
        return (
          <List.Item key={inputProps.id}>
            <List.Item>{inputProps.name}</List.Item>
            <List.Content>{renderElement(inputProps)}</List.Content>
          </List.Item>
        );
      })}
    </List>
  );
};

InputsSection.propTypes = {
  currentSectionPaxData: PropTypes.array.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired
};

export default InputsSection;



// WEBPACK FOOTER //
// ./src/component/TaskCreator/Section/InputsSection.js